"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactToastify = require("react-toastify");

var _formik = require("formik");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _ProfileFormLogout = _interopRequireDefault(require("./ProfileFormLogout"));

var _schemaFiver = _interopRequireDefault(require("./schemaFiver"));

var _schemaToto = _interopRequireDefault(require("./schemaToto"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var ProfileForm = function ProfileForm(_ref) {
  var _profile$address, _profile$address2, _profile$address3, _profile$address4, _profile$address5;

  var translations = _ref.translations,
      setProfile = _ref.setProfile,
      onLogoutSuccess = _ref.onLogoutSuccess,
      onProfileSaveSuccess = _ref.onProfileSaveSuccess,
      onVerifyMobileClicked = _ref.onVerifyMobileClicked,
      onChangePinClicked = _ref.onChangePinClicked,
      onChangePasswordClicked = _ref.onChangePasswordClicked,
      onError = _ref.onError,
      profile = _ref.profile,
      hideVerifyButton = _ref.hideVerifyButton,
      hideChangePin = _ref.hideChangePin,
      hideChangePassword = _ref.hideChangePassword,
      hideLogoutButton = _ref.hideLogoutButton,
      hideAddressTitle = _ref.hideAddressTitle,
      hideEmailField = _ref.hideEmailField,
      showEmailReadonly = _ref.showEmailReadonly,
      hideCity = _ref.hideCity,
      hidePostcode = _ref.hidePostcode,
      hideLine1 = _ref.hideLine1,
      isScore6 = _ref.isScore6,
      isFiver = _ref.isFiver,
      isMinimalAddress = _ref.isMinimalAddress;

  var onSubmit = function onSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting,
        resetForm = _ref2.resetForm;
    var params = {};
    console.log("values", values);
    console.log(profile);

    if (!isScore6) {
      var _values$county, _values$city, _values$line_, _values$line_2;

      params = _objectSpread(_objectSpread(_objectSpread({}, profile), values), {}, {
        address: {
          county: (_values$county = values.county) !== null && _values$county !== void 0 ? _values$county : "",
          city: (_values$city = values.city) !== null && _values$city !== void 0 ? _values$city : "",
          postcode: values.postcode,
          line_1: (_values$line_ = values.line_1) !== null && _values$line_ !== void 0 ? _values$line_ : "",
          line_2: (_values$line_2 = values.line_2) !== null && _values$line_2 !== void 0 ? _values$line_2 : ""
        }
      });
    } else {
      params = {
        firstName: values.firstName,
        lastName: values.lastName,
        mobileNumber: values.mobileNumber,
        termsConditionsAccepted: profile === null || profile === void 0 ? void 0 : profile.termsConditionsAccepted
      };
    }

    console.log("params", params);

    _axios.default.put("/me", params).then(function (_ref3) {
      var _newProfile$address, _newProfile$address2, _newProfile$address3, _newProfile$address4, _newProfile$address5;

      var data = _ref3.data;
      setSubmitting(false);

      _reactToastify.toast.success("".concat(translations.profile, " ").concat(translations.saved));

      var newProfile = data === null || data === void 0 ? void 0 : data.data;
      setProfile(newProfile);
      resetForm({
        values: {
          firstName: newProfile === null || newProfile === void 0 ? void 0 : newProfile.firstName,
          lastName: newProfile === null || newProfile === void 0 ? void 0 : newProfile.lastName,
          email: newProfile === null || newProfile === void 0 ? void 0 : newProfile.email,
          mobileNumber: newProfile === null || newProfile === void 0 ? void 0 : newProfile.mobileNumber,
          line_1: newProfile === null || newProfile === void 0 ? void 0 : (_newProfile$address = newProfile.address) === null || _newProfile$address === void 0 ? void 0 : _newProfile$address.line1,
          line_2: newProfile === null || newProfile === void 0 ? void 0 : (_newProfile$address2 = newProfile.address) === null || _newProfile$address2 === void 0 ? void 0 : _newProfile$address2.line2,
          city: newProfile === null || newProfile === void 0 ? void 0 : (_newProfile$address3 = newProfile.address) === null || _newProfile$address3 === void 0 ? void 0 : _newProfile$address3.city,
          county: newProfile === null || newProfile === void 0 ? void 0 : (_newProfile$address4 = newProfile.address) === null || _newProfile$address4 === void 0 ? void 0 : _newProfile$address4.county,
          postcode: newProfile === null || newProfile === void 0 ? void 0 : (_newProfile$address5 = newProfile.address) === null || _newProfile$address5 === void 0 ? void 0 : _newProfile$address5.postcode,
          emailNotificationsAccepted: false
        }
      });
      onProfileSaveSuccess(newProfile);
      window.xtremepush("set", "user_id", data.data.id);
      window.xtremepush("user", "update", {
        user_id: data.data.id,
        email: data.data.email,
        mobile_number: data.data.mobileNumber,
        first_name: data.data.firstName,
        last_name: data.data.lastName,
        birth_date: data.data.birthDate,
        tenant_id: process.env.REACT_APP_TENANT,
        username: data.data.username,
        sms_subscription: data.data.contactPermissions.smsNotificationsAccepted,
        email_subscription: data.data.contactPermissions.emailNotificationsAccepted,
        push_subscription: data.data.contactPermissions.inAppNotificationsAccepted
      });
    }).catch(function (_ref4) {
      var response = _ref4.response;
      setSubmitting(false);
      onError(response);
      console.log("error", response); //toast.error(translations.networkError);
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Formik, {
    initialValues: {
      firstName: profile === null || profile === void 0 ? void 0 : profile.firstName,
      lastName: profile === null || profile === void 0 ? void 0 : profile.lastName,
      email: profile === null || profile === void 0 ? void 0 : profile.email,
      mobileNumber: profile === null || profile === void 0 ? void 0 : profile.mobileNumber,
      line_1: profile === null || profile === void 0 ? void 0 : (_profile$address = profile.address) === null || _profile$address === void 0 ? void 0 : _profile$address.line1,
      line_2: profile === null || profile === void 0 ? void 0 : (_profile$address2 = profile.address) === null || _profile$address2 === void 0 ? void 0 : _profile$address2.line2,
      city: profile === null || profile === void 0 ? void 0 : (_profile$address3 = profile.address) === null || _profile$address3 === void 0 ? void 0 : _profile$address3.city,
      county: profile === null || profile === void 0 ? void 0 : (_profile$address4 = profile.address) === null || _profile$address4 === void 0 ? void 0 : _profile$address4.county,
      postcode: profile === null || profile === void 0 ? void 0 : (_profile$address5 = profile.address) === null || _profile$address5 === void 0 ? void 0 : _profile$address5.postcode,
      inAppNotificationsAccepted: false,
      smsNotificationsAccepted: false,
      emailNotificationsAccepted: false,
      checkAll: false
    },
    validationSchema: isFiver ? (0, _schemaFiver.default)(translations, true) : (0, _schemaToto.default)(translations, hidePostcode, hideLine1, hideCity),
    onSubmit: onSubmit,
    children: function children(_ref5) {
      var isValid = _ref5.isValid,
          values = _ref5.values,
          errors = _ref5.errors,
          dirty = _ref5.dirty,
          handleChange = _ref5.handleChange,
          isSubmitting = _ref5.isSubmitting;
      console.log("values", values);
      console.log("errors", errors);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Card, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Form, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.TitleStack, {
              title: translations.personalDetails,
              subtitle: translations.personalDetailsSubtitle,
              id: "details-title"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                id: "firstname-field",
                name: "firstName",
                placeholder: translations.firstName,
                value: values.firstName,
                isRequired: true,
                isError: dirty && errors.firstName,
                onChange: handleChange
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
              isVisible: errors.firstName,
              id: "firstname-field",
              children: errors.firstName
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                id: "lastname-field",
                name: "lastName",
                placeholder: translations.lastName,
                value: values.lastName,
                isRequired: true,
                isError: dirty && errors.lastName,
                onChange: handleChange
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
              isVisible: errors.lastName,
              id: "lastname-error",
              children: errors.lastName
            }), !hideEmailField && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                  id: "email-field",
                  type: "email",
                  name: "email",
                  disabled: showEmailReadonly,
                  placeholder: translations.email,
                  value: values.email,
                  isError: dirty && errors.email,
                  onChange: handleChange
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                isVisible: errors.email,
                id: "email-error",
                children: errors.email
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                id: "mobile-field",
                type: "tel",
                name: "mobileNumber",
                placeholder: translations.mobileNumber,
                value: values.mobileNumber,
                isError: errors.mobileNumber,
                onChange: handleChange
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
              isVisible: errors.mobileNumber,
              id: "mobile-error",
              children: errors.mobileNumber
            }), !hideAddressTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                padding: "1rem 0 0"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.TitleStack, {
                title: translations.contactDetails,
                subtitle: translations.contactDetailsSubtitle,
                id: "contact-title"
              })
            }), !hideLine1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                  id: "line1-field",
                  name: "line_1",
                  placeholder: translations.addressLine,
                  value: values.line_1,
                  isError: values.line_1 !== "" && errors.line_1,
                  onChange: handleChange
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                isVisible: values.line_1 !== "" && errors.line_1,
                id: "line1-error",
                children: errors.line_1
              })]
            }), !isMinimalAddress && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                  id: "line1-field",
                  name: "line_2",
                  placeholder: translations.addressLine2,
                  value: values.line_2,
                  isError: dirty && errors.line_2,
                  onChange: handleChange
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                isVisible: errors.line_2,
                id: "line1-error",
                children: errors.line_2
              })]
            }), !hideCity && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                  id: "city-field",
                  name: "city",
                  placeholder: translations.city,
                  value: values.city,
                  isError: values.city !== "" && errors.city,
                  onChange: handleChange
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                isVisible: values.city !== "" && errors.city,
                id: "city-error",
                children: errors.city
              })]
            }), !isMinimalAddress && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                  id: "country-field",
                  name: "county",
                  placeholder: translations.county,
                  value: values.county,
                  isError: dirty && errors.county,
                  onChange: handleChange
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                isVisible: errors.county,
                id: "country-error",
                children: errors.county
              })]
            }), !hidePostcode && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                  id: "postcode-field",
                  name: "postcode",
                  placeholder: translations.postcode,
                  value: values.postcode,
                  isError: dirty && errors.postcode,
                  onChange: handleChange
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                isVisible: errors.postcode,
                id: "postcode-error",
                children: errors.postcode
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
              isLoading: isSubmitting,
              style: {
                marginBottom: "1rem"
              },
              type: "submit",
              disabled: !isValid || !dirty,
              id: "submit-btn",
              children: translations.saveChanges
            }), !hideChangePassword && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
              isDefault: true,
              type: "button",
              onClick: onChangePasswordClicked,
              style: {
                marginBottom: "1rem"
              },
              id: "change-password-btn",
              children: translations.changePassword
            }), !hideChangePin && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
              isDefault: true,
              type: "button",
              onClick: onChangePinClicked,
              style: {
                marginBottom: "1rem"
              },
              id: "change-pin-btn",
              children: translations.changePin
            }), !hideVerifyButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
              isDefault: true,
              type: "button",
              onClick: onVerifyMobileClicked,
              disabled: profile === null || profile === void 0 ? void 0 : profile.mobileNumberVerified,
              disabledSuccess: profile === null || profile === void 0 ? void 0 : profile.mobileNumberVerified,
              style: {
                marginBottom: "1rem"
              },
              id: "verify-btn",
              children: profile !== null && profile !== void 0 && profile.mobileNumberVerified ? translations.mobileNumberVerified : translations.verifyMobile
            }), !hideLogoutButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileFormLogout.default, {
              onLogoutSuccess: onLogoutSuccess,
              onError: onError,
              id: "logout-btn",
              children: translations.logout
            })]
          })
        })
      });
    }
  });
};

var _default = ProfileForm;
exports.default = _default;